import React, { useState } from 'react';

function HoverHint({ text, children }) {
  const [showHint, setShowHint] = useState(false);
  const [position, setPosition] = useState({ x: 0, y: 0 });

  // === 判断是否是移动端 ===
  const isMobile = window.innerWidth <= 768;

  const handleMouseEnter = () => {
    if (isMobile) return; // 移动端不显示
    setShowHint(true);
  };

  const handleMouseMove = (e) => {
    if (isMobile) return;
    setPosition({ x: e.clientX, y: e.clientY });
  };

  const handleMouseLeave = () => {
    if (isMobile) return;
    setShowHint(false);
  };

  // === 小屏下直接不渲染浮层 ===
  if (isMobile) {
    return <>{children}</>;
  }

  return (
    <>
      <div
        onMouseEnter={handleMouseEnter}
        onMouseMove={handleMouseMove}
        onMouseLeave={handleMouseLeave}
        // 确保包裹元素布局正常
      >
        {children}
      </div>

      {showHint && (
        <div
          style={{
            position: 'fixed',
            top: position.y + 12,
            left: position.x + 12,
            background: '#eee',
            padding: '4px 8px',
            fontSize: '12px',
            color: '#555',
            borderRadius: '4px',
            boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
            pointerEvents: 'none',
            zIndex: 9999,
            whiteSpace: 'nowrap',
          }}
        >
          {text}
        </div>
      )}
    </>
  );
}

export default HoverHint;


